<template>
  <div class="container">
    <div class="banner">
      <swiper ref="swiper" />
    </div>
    <div class="build_detail">
      <div class="title">{{ info.building_name || "--" }}</div>
      <div class="meta">
        <div v-if="floorText">{{ floorText }}</div>
        <div v-if="businessText">商圈：{{ businessText }}</div>
        <div v-if="subwayText">地铁：{{ subwayText }}</div>
        <div v-if="addressText">地址：{{ addressText }}</div>
      </div>
      <div class="price">
        <template v-if="hasPrice">
          <span class="num">{{ displayPrice }}</span>
          <span class="unit">元/月</span>
        </template>
        <span v-else class="empty_price">暂无</span>
      </div>
      <div class="tag_list" v-if="buildingTags.length">
        <div
          class="tag_list_item"
          v-for="(item, index) in buildingTags"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="btns phone">
        <img src="../../../assets/image/dh.png" />
        <span>联系电话：{{ bookingPhone }}</span>
      </div>
      <div class="nav_title" v-if="buildingDesc">楼栋描述</div>
      <p class="describe" v-if="buildingDesc">{{ buildingDesc }}</p>
    </div>

    <div class="configuration" v-if="filesList.length">
      <div class="nav_title">楼栋配置</div>
      <div class="icon_list">
        <div
          class="icon_list_item"
          v-for="(item, index) in filesList"
          :key="index"
        >
          <img :src="item.value" />
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>

    <div class="qa_section">
      <div class="nav_title">常见问题</div>
      <div class="qa_list" v-if="contentList.length">
        <div class="qa_item" v-for="(item, index) in contentList" :key="index">
          <div class="qa_question">
            <img src="@/assets/image/wen@2x.png" />
            <span>{{ item.title }}</span>
          </div>
          <div class="qa_answer">
            <img src="@/assets/image/da@2x.png" />
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="qa_empty" v-else>
        <div class="empty_icon">?</div>
        <div class="empty_title">暂无问题</div>
        <div class="empty_desc">该楼栋暂时没有常见问题内容</div>
      </div>
    </div>

    <qrcode ref="qrcode" :showCode="showCode" />
    <mobile-Loading v-if="isLoading" />
  </div>
</template>

<script>
import qrcode from "../components/qrcode";
import swiper from "../components/swiper/index2.vue";
import { getBuildingDetail, qaLists } from "@/api/lookHouse";

export default {
  components: {
    qrcode,
    swiper,
  },
  data() {
    return {
      iconList: [
        { icon: "chuang", name: "床" },
        { icon: "rsq", name: "热水器" },
        { icon: "bx", name: "冰箱" },
        { icon: "xyj", name: "洗衣机" },
        { icon: "yyj", name: "油烟机" },
        { icon: "sf", name: "沙发" },
        { icon: "kt", name: "空调" },
        { icon: "yz", name: "餐椅" },
        { icon: "xg", name: "鞋柜" },
        { icon: "czg", name: "餐桌" },
        { icon: "yg", name: "衣柜" },
        { icon: "wbl", name: "微波炉" },
      ],
      filesList: [],
      contentList: [],
      info: {},
      showCode: false,
      isLoading: true,
    };
  },
  mounted() {
    this.initPageData();
  },
  computed: {
    floorText() {
      const floor = this.info.floor_count;
      const room = this.info.room_count;
      if (floor) return `共${floor}层`;
      if (room) return `共${room}间`;
      return "";
    },
    businessText() {
      return (this.info?.dept?.business_areas || [])
        .map((item) => item.sq_name)
        .filter(Boolean)
        .join("，");
    },
    subwayText() {
      return (this.info?.dept?.stations || [])
        .map((item) => item.station_name)
        .filter(Boolean)
        .join("，");
    },
    addressText() {
      return this.info.address || "";
    },
    hasPrice() {
      const min = this.info.min_price;
      const max = this.info.max_price;
      return (
        min !== null &&
        min !== undefined &&
        min !== "" &&
        max !== null &&
        max !== undefined &&
        max !== ""
      );
    },
    displayPrice() {
      if (!this.hasPrice) return "暂无";
      return `${Number(this.info.min_price).toFixed(0)}-${Number(
        this.info.max_price
      ).toFixed(0)}`;
    },
    buildingTags() {
      return (this.info.labels || [])
        .map((item) => item.bq_name || item.name || item)
        .filter(Boolean);
    },
    buildingDesc() {
      return (
        this.info.brief_info ||
        this.info.description ||
        this.info.building_desc ||
        this.info.desc ||
        ""
      );
    },
    bookingPhone() {
      return (
        (this.info.booking_advice_info &&
          this.info.booking_advice_info.booking_line) ||
        this.info.booking_line ||
        "400-188-3001"
      );
    },
  },
  methods: {
    initPageData() {
      this.isLoading = true;
      Promise.all([this.initData(), this.initContent()]).finally(() => {
        this.isLoading = false;
      });
    },
    initData() {
      return getBuildingDetail({ building_id: this.$route.query.id }).then(
        (res) => {
          const data = res.data || {};
          this.info = data;
          this.$refs.swiper.bannerList = data.files || [];
          this.$refs.swiper.onChangeSwiper();

          if (this.$refs.qrcode && data.booking_advice_info?.qrcode?.src) {
            this.$refs.qrcode.path = data.booking_advice_info.qrcode.src;
          }

          let iconList = [];
          this.iconList.forEach((item) => {
            (data.labels || []).forEach((item2) => {
              if (item.name == item2.bq_name) {
                iconList.push({
                  label: item2.bq_name,
                  value: item2.cover_host + item2.cover_path,
                });
              }
            });
          });
          this.filesList = iconList.slice(0, 12);
        }
      );
    },
    initContent() {
      return qaLists({ building_id: this.$route.query.id }).then((res) => {
        this.contentList = res.data || [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
.nav_title {
  color: #333333;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 30px;
}
.container {
  color: #666666;
  font-size: 28px;
  .banner {
    img,
    video {
      width: 100%;
      height: 500px;
      object-fit: cover;
    }
  }
  .build_detail {
    padding: 24px 30px 36px;
    box-sizing: border-box;
    background: #ffffff;
    .title {
      color: #333333;
      font-size: 36px;
      font-weight: bold;
      line-height: 50px;
    }
    .meta {
      color: #999999;
      font-size: 24px;
      line-height: 40px;
      margin: 6px 0 8px;
    }
    .price {
      margin: 8px 0 14px;
      .num {
        color: #ff4d4d;
        font-size: 36px;
        font-weight: bold;
      }
      .unit {
        color: #666666;
        font-size: 24px;
      }
      .empty_price {
        color: #999999;
        font-size: 30px;
        font-weight: bold;
      }
    }
    .tag_list {
      display: flex;
      flex-wrap: wrap;
      column-gap: 16px;
      row-gap: 16px;
      margin-bottom: 38px;
      &_item {
        color: #999999;
        font-size: 22px;
        padding: 6px 8px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: #f4f4f4;
        flex-shrink: 0;
      }
    }
    .btns {
      width: 100%;
      height: 80px;
      border-radius: 10px;
      color: #ffffff;
      background: #ffa71d;
      font-size: 28px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 13px;
      margin: 26px 0 44px;
      img {
        width: 36px;
        height: 36px;
      }
    }
    .describe {
      color: #666666;
      font-size: 28px;
      line-height: 48px;
      text-indent: 2em;
      margin: 0;
    }
  }
  .configuration {
    padding: 34px 30px 50px;
    box-sizing: border-box;
    background: #f5f5f5;
    .icon_list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 34px 40px;
      color: #666666;
      font-size: 24px;
      &_item {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        align-items: center;
        justify-content: center;
        img {
          width: 56px;
          height: 56px;
          object-fit: cover;
        }
      }
    }
  }
  .qa_section {
    padding: 34px 30px 44px;
    box-sizing: border-box;
    background: #ffffff;
    .qa_list {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
    }
    .qa_item {
      padding: 24px 22px;
      box-sizing: border-box;
      border-radius: 12px;
      background: #f5f5f5;
    }
    .qa_question,
    .qa_answer {
      display: flex;
      column-gap: 14px;
      img {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
        margin-top: 3px;
      }
      span {
        line-height: 40px;
      }
    }
    .qa_question {
      margin-bottom: 14px;
      color: #333333;
      font-size: 28px;
      font-weight: bold;
    }
    .qa_answer {
      color: #666666;
      font-size: 24px;
    }
    .qa_empty {
      min-height: 260px;
      border-radius: 12px;
      background: #f5f5f5;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #999999;
      .empty_icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #ffa71d;
        color: #ffffff;
        font-size: 34px;
        font-weight: bold;
        line-height: 56px;
        text-align: center;
        margin-bottom: 18px;
      }
      .empty_title {
        color: #333333;
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .empty_desc {
        font-size: 22px;
      }
    }
  }
}
</style>
